<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

const emit = defineEmits(['click']);

defineProps({
  loading: {
    required: true,
    type: Boolean,
  },
  data: {
    required: true,
    type: Object,
  },
});

</script>

<template>
  <div class="tw-px-8 tw-pb-8 tw-flex tw-flex-col tw-gap-16 tw-justify-center">
    <div class="tw-flex tw-justify-between tw-items-center">
      <h2 class="tw-text-2.5xl tw-text-grey-dark tw-font-bold">
        Content Wizard
      </h2>
    </div>

    <div class="tw-text-lg tw-text-font-secondary tw-space-y-4">
      <p class="tw-leading-snug">
        Let the Content Wizard work it's magic for your SEO!
      </p>
      <p class="tw-leading-snug">
        Using the keywords you have assigned to this page, the Wizard is going to generate 3
        options for its page title, meta description and main heading.
      </p>
      <p class="tw-leading-snug">
        Use them exactly, or use them only as a guide, but please note that the platform might
        find further SEO opportunities for them within your actions.
      </p>
    </div>

    <div class="tw-flex tw-justify-center tw-items-center tw-flex-col tw-gap-3">
      <DefaultButton
        v-if="!loading"
        class="tw-self-center"
        :disabled="data.credits < 1"
        @click="emit('click')"
      >
        <span class="tw-font-semibold tw-antialiased">Run Content Wizard</span>
        <svg-vue
          icon="icons/stars"
          class="tw-w-6 tw-h-6 tw-ml-2"
        />
      </DefaultButton>

      <div
        v-else
        class="tw-flex tw-items-center tw-gap-3"
      >
        <span class="tw-font-bold tw-text-grey-dark tw-text-xl">
          Running Content Wizard
        </span>
        <svg-vue
          icon="icons/loading"
          class="tw-w-6 tw-h-6 tw-text-blue"
        />
      </div>
    </div>
  </div>
</template>
